(() => {
  const SELECTOR = '[data-aq-file-upload]';
  const PHONE_REGEX = /^\+[1-9]\d{7,14}$/;
  const SOCIAL_PLATFORMS = ['instagram', 'facebook'];

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTOR).forEach(initBlock);
  });

  function initBlock(root) {
    const form = root.querySelector('.aq-upload-form');
    const status = root.querySelector('[data-aq-status]');
    const submitButton = root.querySelector('.aq-upload-button');
    const successModal = root.querySelector('[data-aq-success-modal]');
    const successCloseButtons = root.querySelectorAll('[data-aq-success-close]');
    const apiBaseUrl = (root.dataset.apiBaseUrl || '').trim().replace(/\/$/, '');
    const maxUploadBytes = Number(root.dataset.maxUploadBytes || 26214400);
    const maxFilesPerWork = Number(root.dataset.maxFiles || 3);
    const allowMultipleFiles = root.dataset.allowMultipleFiles === 'true';
    const shopDomain = root.dataset.shopDomain || '';
    const socialExceptionCheckbox = root.querySelector('input[name="socialPostException"]');
    const workStates = Array.from(root.querySelectorAll('[data-aq-work-card]')).map(buildWorkState);

    if (!form || !submitButton || !successModal || !socialExceptionCheckbox || !workStates.length) return;

    successCloseButtons.forEach((button) => {
      button.addEventListener('click', () => closeSuccessModal(successModal));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !successModal.hidden) {
        closeSuccessModal(successModal);
      }
    });

    socialExceptionCheckbox.addEventListener('change', updateSocialFieldsVisibility);

    workStates.forEach((state) => {
      if (state.fileInput) {
        state.fileInput.addEventListener('change', () => {
          const newlyPickedFiles = Array.from(state.fileInput.files || []).map(createFileItem);
          if (!newlyPickedFiles.length) return;

          let mergedFiles = allowMultipleFiles
            ? mergeFiles(state.selectedFiles, newlyPickedFiles)
            : newlyPickedFiles.slice(0, 1);

          let limitExceeded = false;
          if (mergedFiles.length > maxFilesPerWork) {
            mergedFiles = mergedFiles.slice(0, maxFilesPerWork);
            limitExceeded = true;
          }

          state.selectedFiles = mergedFiles;
          renderWorkFileList(state);

          if (limitExceeded) {
            setStatus(
              status,
              `Für Kunstwerk ${state.workNumber} sind maximal ${maxFilesPerWork} Medien erlaubt. Zusätzliche Dateien wurden nicht übernommen.`,
              'error'
            );
          } else {
            clearStatus(status);
          }

          state.fileInput.value = '';
        });
      }

      if (state.fileList) {
        state.fileList.addEventListener('click', (event) => {
          const removeButton = event.target.closest('[data-aq-remove-file]');
          if (!removeButton) return;

          const fileId = removeButton.getAttribute('data-aq-remove-file');
          const targetFile = state.selectedFiles.find((item) => item.id === fileId);
          if (!targetFile || targetFile.status === 'uploading') return;

          state.selectedFiles = state.selectedFiles.filter((item) => item.id !== fileId);
          renderWorkFileList(state);

          if (!hasAnySelectedFiles(workStates)) {
            clearStatus(status);
          }
        });
      }

      renderWorkFileList(state);
    });

    updateSocialFieldsVisibility();

    submitButton.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      clearStatus(status);

      if (!apiBaseUrl) {
        setStatus(status, 'Die Cloudflare Worker URL fehlt in den Section-Einstellungen.', 'error');
        return;
      }

      const formData = new FormData(form);
      const firstName = String(formData.get('firstName') || '').trim();
      const lastName = String(formData.get('lastName') || '').trim();
      const email = String(formData.get('email') || '').trim();
      const countryCode = String(formData.get('countryCode') || '').trim();
      const socialPostException = Boolean(formData.get('socialPostException'));
      const rawPhone = String(formData.get('phoneNumber') || '').trim();
      const phoneNumber = normalizePhone(rawPhone);
      const works = collectWorks(workStates);
      const activeWorks = works.filter((work) => work.isActive);
      const uploadQueue = buildUploadQueue(activeWorks);

      if (!firstName) {
        setStatus(status, 'Bitte den Vornamen eingeben.', 'error');
        return;
      }

      if (!lastName) {
        setStatus(status, 'Bitte den Nachnamen eingeben.', 'error');
        return;
      }

      if (!email) {
        setStatus(status, 'Bitte eine E-Mail-Adresse eingeben.', 'error');
        return;
      }

      if (!countryCode || !/^[A-Z]{2}$/.test(countryCode)) {
        setStatus(status, 'Bitte ein gültiges Wohnsitzland auswählen.', 'error');
        return;
      }

      if (!formData.get('legalAccepted')) {
        setStatus(status, 'Bitte die Pflicht-Checkbox bestätigen.', 'error');
        return;
      }

      if (phoneNumber && !PHONE_REGEX.test(phoneNumber)) {
        setStatus(status, 'Bitte die Telefonnummer im Format +43…, +49… oder +41… eingeben.', 'error');
        return;
      }

      if (!activeWorks.length) {
        setStatus(status, 'Bitte mindestens ein Kunstwerk mit den zugehörigen Angaben und Upload-Medien ausfüllen.', 'error');
        return;
      }

      for (const work of activeWorks) {
        if (!work.artisticIdea) {
          setStatus(status, `Bitte beim Kunstwerk ${work.workNumber} die künstlerische Idee und die verwendeten Aquarylic Materialien angeben.`, 'error');
          return;
        }

        if (!work.files.length) {
          setStatus(status, `Bitte beim Kunstwerk ${work.workNumber} mindestens ein Medium hochladen.`, 'error');
          return;
        }

        if (!socialPostException) {
          if (!work.socialPlatform || !SOCIAL_PLATFORMS.includes(work.socialPlatform)) {
            setStatus(status, `Bitte beim Kunstwerk ${work.workNumber} eine gültige Plattform auswählen.`, 'error');
            return;
          }

          if (!work.socialPostUrl) {
            setStatus(status, `Bitte beim Kunstwerk ${work.workNumber} den Link zum veröffentlichten Beitrag eingeben.`, 'error');
            return;
          }

          if (!isValidSocialUrl(work.socialPostUrl, work.socialPlatform)) {
            setStatus(status, `Bitte beim Kunstwerk ${work.workNumber} einen gültigen Instagram- oder Facebook-Link eingeben.`, 'error');
            return;
          }
        }

        for (const item of work.files) {
          if (item.file.size > maxUploadBytes) {
            setStatus(status, `Die Datei "${item.file.name}" bei Kunstwerk ${work.workNumber} ist zu groß.`, 'error');
            return;
          }
        }
      }

      setBusy(submitButton, true);

      try {
        const submissionGroupId = self.crypto?.randomUUID
          ? self.crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

        for (let index = 0; index < uploadQueue.length; index += 1) {
          const entry = uploadQueue[index];
          const { workNumber, mediaIndex, mediaTotal, item } = entry;
          const { file } = item;

          updateFileStatus(item, 'uploading');
          renderWorkFileList(getWorkState(workStates, workNumber));
          setStatus(status, `Kunstwerk ${workNumber}: Medium ${mediaIndex + 1} von ${mediaTotal} wird hochgeladen… (${index + 1}/${uploadQueue.length})`, 'info');

          const initResponse = await fetch(`${apiBaseUrl}/api/upload/init`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email,
              filename: file.name,
              contentType: file.type || 'application/octet-stream',
              sizeBytes: file.size,
              sourceUrl: window.location.href,
              company: String(formData.get('company') || ''),
              shopDomain,
              submissionGroupId,
              fileIndex: index,
              totalFiles: uploadQueue.length,
              workNumber,
              workMediaIndex: mediaIndex,
              workMediaTotal: mediaTotal,
            }),
          });

          const initJson = await safeJson(initResponse);
          if (!initResponse.ok || !initJson?.ok) {
            updateFileStatus(item, 'error');
            renderWorkFileList(getWorkState(workStates, workNumber));
            throw new Error(initJson?.error || 'Upload konnte nicht initialisiert werden.');
          }

          const uploadResponse = await fetch(initJson.uploadUrl, {
            method: 'PUT',
            headers: initJson.requiredHeaders || {
              'Content-Type': file.type || 'application/octet-stream',
            },
            body: file,
          });

          if (!uploadResponse.ok) {
            updateFileStatus(item, 'error');
            renderWorkFileList(getWorkState(workStates, workNumber));
            throw new Error(`Datei "${file.name}" konnte nicht zu R2 hochgeladen werden.`);
          }

          const completeResponse = await fetch(`${apiBaseUrl}/api/upload/complete`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              uploadId: initJson.uploadId,
              submissionGroupId,
              triggerKlaviyo: index === uploadQueue.length - 1,
              email,
              firstName,
              lastName,
              phoneNumber,
              socialPostException,
              works: works.map((work) => ({
                workNumber: work.workNumber,
                isActive: work.isActive,
                socialPlatform: work.socialPlatform,
                socialPostUrl: work.socialPostUrl,
                artisticIdea: work.artisticIdea,
                workTitle: work.workTitle,
                mediaCount: work.files.length,
                mediaFiles: work.files.map((workFile, workFileIndex) => ({
                  index: workFileIndex,
                  filename: workFile.file.name,
                  contentType: workFile.file.type || 'application/octet-stream',
                  sizeBytes: workFile.file.size,
                })),
              })),
              countryCode,
              orderReference: String(formData.get('orderReference') || ''),
              message: String(formData.get('message') || ''),
              consentMarketing: Boolean(formData.get('consentMarketing')),
              legalAccepted: Boolean(formData.get('legalAccepted')),
              sourceUrl: window.location.href,
              shopDomain,
            }),
          });

          const completeJson = await safeJson(completeResponse);
          if (!completeResponse.ok || !completeJson?.ok) {
            updateFileStatus(item, 'error');
            renderWorkFileList(getWorkState(workStates, workNumber));
            throw new Error(completeJson?.error || 'Upload konnte nicht abgeschlossen werden.');
          }

          updateFileStatus(item, 'uploaded');
          renderWorkFileList(getWorkState(workStates, workNumber));
        }

        form.reset();
        workStates.forEach((state) => {
          state.selectedFiles = [];
          renderWorkFileList(state);
          if (state.fileInput) state.fileInput.value = '';
        });
        updateSocialFieldsVisibility();
        clearStatus(status);
        openSuccessModal(successModal);
      } catch (error) {
        console.error('AQ upload error:', error);
        setStatus(status, error.message || 'Es ist ein Fehler aufgetreten.', 'error');
      } finally {
        setBusy(submitButton, false);
      }
    });

    function updateSocialFieldsVisibility() {
      const isException = socialExceptionCheckbox.checked;

      workStates.forEach((state) => {
        state.socialFields.forEach((field) => {
          field.hidden = isException;
          field.style.display = isException ? 'none' : '';
        });

        if (state.socialPlatformInput) {
          state.socialPlatformInput.required = false;
          state.socialPlatformInput.disabled = isException;
        }

        if (state.socialPostUrlInput) {
          state.socialPostUrlInput.required = false;
          state.socialPostUrlInput.disabled = isException;
        }
      });
    }
  }

  function buildWorkState(card, index) {
    return {
      card,
      workNumber: Number(card.dataset.workNumber || index + 1),
      socialFields: Array.from(card.querySelectorAll('[data-aq-work-social-fields]')),
      socialPlatformInput: card.querySelector('[data-aq-work-field="socialPlatform"]'),
      socialPostUrlInput: card.querySelector('[data-aq-work-field="socialPostUrl"]'),
      artisticIdeaInput: card.querySelector('[data-aq-work-field="artisticIdea"]'),
      workTitleInput: card.querySelector('[data-aq-work-field="workTitle"]'),
      fileInput: card.querySelector('[data-aq-work-file-input]'),
      fileListWrapper: card.querySelector('[data-aq-file-list-wrapper]'),
      fileList: card.querySelector('[data-aq-file-list]'),
      selectedFiles: [],
    };
  }

  function collectWorks(workStates) {
    return workStates.map((state) => {
      const socialPlatform = String(state.socialPlatformInput?.value || '').trim().toLowerCase();
      const socialPostUrl = String(state.socialPostUrlInput?.value || '').trim();
      const artisticIdea = String(state.artisticIdeaInput?.value || '').trim();
      const workTitle = String(state.workTitleInput?.value || '').trim();
      const mediaFiles = state.selectedFiles.map((item, index) => ({
        index,
        filename: item.file.name,
        contentType: item.file.type || 'application/octet-stream',
        sizeBytes: item.file.size,
      }));
      const hasAnyValue = Boolean(socialPlatform || socialPostUrl || artisticIdea || workTitle || state.selectedFiles.length);

      return {
        workNumber: state.workNumber,
        socialPlatform,
        socialPostUrl,
        artisticIdea,
        workTitle,
        mediaCount: state.selectedFiles.length,
        mediaFiles,
        files: [...state.selectedFiles],
        isActive: hasAnyValue,
      };
    });
  }

  function buildUploadQueue(activeWorks) {
    return activeWorks.flatMap((work) =>
      work.files.map((item, mediaIndex) => ({
        workNumber: work.workNumber,
        mediaIndex,
        mediaTotal: work.files.length,
        item,
      }))
    );
  }

  function getWorkState(workStates, workNumber) {
    return workStates.find((state) => state.workNumber === Number(workNumber)) || null;
  }

  function hasAnySelectedFiles(workStates) {
    return workStates.some((state) => state.selectedFiles.length > 0);
  }

  function createFileItem(file) {
    return {
      id: buildFileId(file),
      file,
      status: 'ready',
    };
  }

  function buildFileId(file) {
    return `${file.name}__${file.size}__${file.lastModified}`;
  }

  function mergeFiles(existingFiles, newFiles) {
    const map = new Map();

    [...existingFiles, ...newFiles].forEach((item) => {
      if (!map.has(item.id)) {
        map.set(item.id, item);
      }
    });

    return Array.from(map.values());
  }

  function updateFileStatus(item, nextStatus) {
    if (!item) return;
    item.status = nextStatus;
  }

  function renderWorkFileList(state) {
    if (!state?.fileListWrapper || !state.fileList) return;

    if (!state.selectedFiles.length) {
      state.fileListWrapper.hidden = true;
      state.fileList.innerHTML = '';
      return;
    }

    state.fileListWrapper.hidden = false;
    state.fileList.innerHTML = state.selectedFiles
      .map((item) => {
        const removable = item.status === 'ready' || item.status === 'error';

        return `
          <li class="aq-upload-file-item">
            <div class="aq-upload-file-meta">
              <div class="aq-upload-file-name">${escapeHtml(item.file.name)}</div>
              <div class="aq-upload-file-subline">
                <span>${formatFileSize(item.file.size)}</span>
                <span class="aq-upload-file-badge" data-state="${item.status}">
                  ${getStatusLabel(item.status)}
                </span>
              </div>
            </div>
            <button
              class="aq-upload-file-remove"
              type="button"
              data-aq-remove-file="${escapeHtml(item.id)}"
              ${removable ? '' : 'disabled'}
              aria-label="Datei ${escapeHtml(item.file.name)} entfernen"
            >
              Entfernen
            </button>
          </li>
        `;
      })
      .join('');
  }

  function getStatusLabel(status) {
    if (status === 'uploading') return 'Wird hochgeladen';
    if (status === 'uploaded') return 'Übermittelt';
    if (status === 'error') return 'Fehler';
    return 'Ausgewählt';
  }

  function formatFileSize(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }

  function normalizePhone(value) {
    if (!value) return '';
    return value.replace(/[\s().-]/g, '');
  }

  function openSuccessModal(modal) {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('aq-upload-modal-open');
  }

  function closeSuccessModal(modal) {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('aq-upload-modal-open');
  }

  function setBusy(button, isBusy) {
    if (!button) return;
    button.disabled = isBusy;
    button.dataset.originalLabel ||= button.textContent;
    button.textContent = isBusy ? 'Wird hochgeladen…' : button.dataset.originalLabel;
  }

  function setStatus(node, message, type) {
    if (!node) return;
    node.hidden = false;
    node.textContent = message;
    node.setAttribute('data-state', type);
  }

  function clearStatus(node) {
    if (!node) return;
    node.hidden = true;
    node.textContent = '';
    node.removeAttribute('data-state');
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  function isValidSocialUrl(value, platform) {
    try {
      const url = new URL(value);
      const host = url.hostname.toLowerCase();

      if (platform === 'instagram') {
        return host.includes('instagram.com');
      }

      if (platform === 'facebook') {
        return host.includes('facebook.com') || host.includes('fb.watch') || host.includes('m.facebook.com');
      }

      return false;
    } catch {
      return false;
    }
  }

  async function safeJson(response) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }
})();
